// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hubspot-integration-container {
  background: #ffffff;
  min-height: calc(100vh - 64px);
}

.hubspot-header {
  background: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-bottom: 1px solid #d3e1ed;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hubspot-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-button:hover {
  opacity: 0.7;
}

.breadcrumb {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #40a0c1;
  margin-bottom: 0;
}

.breadcrumb-separator {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #142a31;
  margin: 0 8px;
}

.breadcrumb-current {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #142a31;
}

.hubspot-info-section {
  padding: 30px 24px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.hubspot-info-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hubspot-title-group {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 55.68px;
}

.hubspot-logo-wrapper {
  width: 55.68px;
  height: 55.68px;
  border-radius: 50%;
  box-shadow: 0px 9px 13px 0px rgba(129, 155, 163, 0.12), 0px 0px 3px 0px rgba(20, 43, 49, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hubspot-logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.hubspot-info-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 75.68px;
}

.hubspot-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0;
}

.hubspot-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0;
  max-width: 428px;
}

.hubspot-expiry {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.hubspot-expiry-label {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 1.21;
  color: #365a64;
  margin: 0;
}

.hubspot-expiry-date {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.21;
  color: #365a64;
  margin: 0;
}

.hubspot-info-actions {
  display: flex;
  gap: 12px;
}

.disconnect-button {
  padding: 7px 11px;
  background: #142a31;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.disconnect-button:hover {
  background: #1f3d47;
}

.connect-to-ace-button {
  padding: 7px 11px;
  background: #40a0c1;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.connect-to-ace-button:hover {
  background: #2c83a0;
}
.connect-to-ace-button img {
  width: 21px;
  height: 21px;
  margin-right: 8px;
}

.hubspot-tabs {
  display: flex;
  gap: 24px;
  padding: 0 24px;
  border-bottom: 1px solid #d3e1ed;
  background: #ffffff;
}

.hubspot-tab {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.21;
  color: #062229;
  background: transparent;
  border: none;
  padding: 12px 0;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}
.hubspot-tab.active {
  font-weight: 700;
  color: #062229;
}
.hubspot-tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background: #40a0c1;
  border-radius: 0;
}
.hubspot-tab:hover {
  opacity: 0.7;
}

.delete-icon {
  width: 16px;
  height: 16px;
}

.automation-alerts-content {
  background: #ffffff;
  min-height: 400px;
}

.automation-indicator-bar {
  width: 141px;
  height: 5px;
  background: #40a0c1;
  border-radius: 7px;
  margin-left: 101px;
  margin-bottom: 8px;
}

.automation-section-title {
  background: #f5f9ff;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.21;
  color: #6a8991;
  padding: 12px 24px;
  border-bottom: 1px solid #d3e1ed;
}

.automation-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 24px;
  padding: 16px 24px;
  border-bottom: 1px solid #d3e1ed;
}
.automation-row:last-child {
  margin-bottom: 0;
}

.automation-label {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.21;
  color: #6a8991;
}

.toggle-switch {
  display: flex;
  border: 0.64px solid #e5edef;
  border-radius: 3.83px;
  overflow: hidden;
  background: #ffffff;
  width: 86px;
  height: 29.37px;
  position: relative;
}

.toggle-option {
  padding: 0;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.21;
  color: #000000;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  height: 100%;
}
.toggle-option span {
  display: block;
}
.toggle-option.selected {
  background: #40a0c1;
  font-weight: 700;
  color: #ffffff;
  border-radius: 3.83px 0 0 3.83px;
  width: 42.14px;
}
.toggle-option:not(.selected) {
  color: #000000;
  font-weight: 400;
}
.toggle-option:hover:not(.selected) {
  background: #f5f9ff;
}

.automation-input {
  width: 86px;
  height: 31px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #062229;
  outline: none;
  box-sizing: border-box;
  margin-left: 24px;
}
.automation-input::placeholder {
  color: #6a8991;
}

.automation-triggers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}

.trigger-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: #40a0c1;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.21;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s;
}
.trigger-button:hover {
  background: #3690b1;
}
.trigger-button svg {
  width: 15px;
  height: 15px;
}

.trigger-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0px 24px 36px 24px;
}

.trigger-card {
  background: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-bottom: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 16px 24px;
  max-width: 624px;
}

.trigger-card-header {
  margin-bottom: 12px;
}

.trigger-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.trigger-name {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.21;
  color: #062229;
}

.trigger-status {
  padding: 5px 10px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.21;
}
.trigger-status.active {
  background: rgba(64, 160, 193, 0.2);
  color: #40a0c1;
}
.trigger-status.inactive {
  background: rgba(106, 137, 145, 0.19);
  color: #6a8991;
}

.trigger-card-content {
  background: #ffffff;
  border: 1px solid #e0e6eb;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 12px;
}

.trigger-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.21;
  color: #062229;
  margin: 0;
}

.trigger-card-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.trigger-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.21;
  color: #6a8991;
}

.trigger-separator {
  color: #d3e1ed;
}

.trigger-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.trigger-action-icon {
  cursor: pointer;
  transition: all 0.2s;
}
.trigger-action-icon.edit-icon, .trigger-action-icon.delete-icon {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(59%) sepia(8%) saturate(959%) hue-rotate(143deg) brightness(91%) contrast(90%);
}
.trigger-action-icon:hover {
  opacity: 0.7;
}

.trigger-action-link {
  background: transparent;
  border: none;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.21;
  color: #6a8991;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s;
}
.trigger-action-link:hover {
  opacity: 0.7;
}

.profile-indicator {
  width: 66px;
  height: 5px;
  background: #40a0c1;
  border-radius: 7px;
}

.mapping-profile-tabs {
  display: flex;
  align-items: flex-start;
}

.profile-tabs-list {
  display: flex;
  align-items: flex-end;
  gap: 0;
}

.profile-tab-container {
  position: relative;
}

.profile-tab {
  background: #f5f9ff;
  border: none;
  border-radius: 5px 5px 0 0;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.profile-tab.active {
  background: #ffffff;
  border: 1px solid #dbe7f1;
  border-bottom: none;
}

.profile-tab-divider {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 14px;
  border-right: 1px solid #d3e1ed;
}

.profile-tab-text {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #6a8991;
}

.profile-tab-border {
  background: #ffffff;
  height: 3px;
  width: 100%;
  position: absolute;
  bottom: -3px;
  left: 0;
}

.profile-user-list {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
  margin-left: auto;
}

.profile-user {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #6a8991;
  cursor: pointer;
}
.profile-user:hover {
  opacity: 0.7;
}

.profile-separator {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #d3e1ed;
}

.profile-add-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-add-button:hover {
  opacity: 0.7;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.section-header-simple {
  margin-bottom: 16px;
}

.section-indicator {
  width: 51px;
  height: 5px;
  background: #40a0c1;
  border-radius: 7px;
}

.section-filters {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.filter-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 13px;
  height: 34px;
  color: #142a31;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.filter-dropdown:hover {
  border-color: #94a3b8;
}
.filter-dropdown span {
  color: #142a31;
  font-size: 13px;
  white-space: nowrap;
}
.filter-dropdown select {
  border: none;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #142a31;
  cursor: pointer;
  outline: none;
  appearance: none;
  padding-right: 16px;
}
.filter-dropdown .dropdown-icon {
  position: absolute;
  right: 14px;
  pointer-events: none;
}

.field-name-wrapper {
  margin-top: 16px;
}

.field-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 280px;
}

.field-name-input-container {
  position: relative;
  height: 31px;
}

.field-name-input {
  width: 100%;
  height: 42px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #062229;
  outline: none;
  box-sizing: border-box;
}
.field-name-input::placeholder {
  color: #6a8991;
}

.field-name-dropdown-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.field-add-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.field-add-button:hover {
  opacity: 0.7;
}

.field-row {
  display: grid;
  grid-template-columns: 120px 1fr auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
}
.field-row.field-row-last {
  margin-bottom: 32px;
}

.field-label {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #6a8991;
}

.field-input {
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #062229;
  outline: none;
}
.field-input::placeholder {
  color: #6a8991;
}

.field-select {
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #062229;
  outline: none;
  appearance: none;
  cursor: pointer;
}

.dropdown-icon-field {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.dropdown-icon-select {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.field-actions {
  display: flex;
  gap: 8px;
  cursor: pointer;
}
.field-actions:hover {
  opacity: 0.7;
}

.mapping-table-header-row {
  background: #fbfcff;
  border: 1px solid #e0e6eb;
  border-bottom: 1px solid #d3e1ed;
}

.mapping-table-header-cell {
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #6a8991;
  background-color: #fbfcff;
}

.expand-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
  transform: rotate(180deg);
  margin-right: 12px;
  margin-bottom: 2px;
}
.expand-icon.expanded {
  transform: rotate(0deg);
}

.mapping-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  display: table;
  border: none;
}

.mapping-table thead {
  display: table-header-group;
}

.mapping-table tbody {
  display: table-row-group;
}

.mapping-table tr {
  display: table-row;
}

.mapping-table th,
.mapping-table td {
  display: table-cell;
}

.mapping-table-subheader {
  background: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-bottom: 1px solid #d3e1ed;
}

.mapping-table-subheader th {
  padding: 12px 10px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0 !important;
}
.mapping-table-subheader th:nth-child(1), .mapping-table-subheader th:nth-child(2) {
  width: 20%;
}
.mapping-table-subheader th:nth-child(3) {
  width: 25%;
}
.mapping-table-subheader th:nth-child(4) {
  width: 8%;
}
.mapping-table-subheader th:nth-child(5) {
  width: 12%;
}
.mapping-table-subheader th:nth-child(6) {
  width: 20%;
}

.mapping-column-header {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #6a8991;
}
.mapping-column-header.mapped-header {
  text-align: center;
  align-items: center;
  justify-content: center;
}

.mapping-table-row {
  background: #ffffff;
  border-top: none;
}
.mapping-table-row:nth-child(even) {
  background: #f5f9ff;
}

.mapping-table-row td {
  padding: 10px 10px;
}
.mapping-table-row td:last-child {
  border-right: none;
}

.mapping-cell {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #142a31;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
}

.mapping-cell-text {
  display: block;
  max-width: 100%;
  flex: 1 1;
  min-width: 0;
  align-items: flex-start;
}

.mapped-cell {
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: visible !important;
}

.opportunity-field-select-container {
  position: relative;
  width: 100%;
  min-height: 31px;
}
.opportunity-field-select-container.has-hint .field-dropdown-wrapper {
  margin-top: 20px;
}

.mapping-table-row:not(.has-hint-row) td {
  padding-top: 20px;
}

.field-hint {
  font-size: 11px;
  color: #706e6b;
  margin-top: 4px;
  font-style: italic;
  line-height: 1.4;
  font-weight: 400;
}
.field-hint a {
  color: #0176d3;
  text-decoration: none;
}
.field-hint a:hover {
  text-decoration: underline;
}

.opportunity-select {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 32px 8px 10px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #142a31;
  outline: none;
  appearance: none;
  cursor: pointer;
  box-sizing: border-box;
}

.mapping-select {
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 0px 20px 0px 6px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #062229;
  outline: none;
  appearance: none;
  cursor: pointer;
  flex: 1 1;
}

.dropdown-icon-inline {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.edit-icon {
  cursor: pointer;
}
.edit-icon:hover {
  opacity: 0.7;
}

.default-value-cell {
  color: #88abb4;
}

.map-values-button {
  padding: 7px 11px;
  background: #142a31;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s;
  height: 40px;
}
.map-values-button:hover {
  background: #1f3d47;
}

.disconnect-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 20px 0;
}

.disconnect-modal-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 30px 0;
  max-width: 300px;
}

.disconnect-modal-buttons {
  display: flex;
  gap: 12px;
}

.disconnect-modal-cancel {
  padding: 8px 29px;
  background: transparent;
  color: #142a31;
  border: 1px solid #d3e1ed;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.disconnect-modal-cancel:hover {
  background: #f5f9ff;
}

.disconnect-modal-confirm {
  padding: 8px 29px;
  background: #142a31;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.disconnect-modal-confirm:hover {
  background: #1f3d47;
}

.duplicate-mapping-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 8px 0;
  text-align: left;
}

.duplicate-mapping-modal-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 24px 0;
  text-align: left;
}
.duplicate-mapping-modal-description strong {
  font-weight: 600;
  color: #142a31;
}

.duplicate-mapping-modal-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
}

.duplicate-mapping-modal-label {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #142a31;
}
.duplicate-mapping-modal-label .required {
  color: #ef4444;
  margin-left: 2px;
}

.duplicate-mapping-modal-input {
  padding: 10px 12px;
  border: 1px solid #d3e1ed;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #142a31;
  outline: none;
  transition: border-color 0.2s;
}
.duplicate-mapping-modal-input:focus {
  border-color: #40a0c1;
}
.duplicate-mapping-modal-input.error {
  border-color: #ef4444;
}
.duplicate-mapping-modal-input::placeholder {
  color: #88abb4;
}

.duplicate-mapping-modal-error {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #ef4444;
  margin-top: -4px;
}

.duplicate-mapping-modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.duplicate-mapping-modal-cancel {
  padding: 8px 29px;
  background: transparent;
  color: #142a31;
  border: 1px solid #d3e1ed;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.duplicate-mapping-modal-cancel:hover {
  background: #f5f9ff;
}

.duplicate-mapping-modal-confirm {
  padding: 8px 29px;
  background: #40a0c1;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.duplicate-mapping-modal-confirm:hover:not(:disabled) {
  background: #338ba8;
}
.duplicate-mapping-modal-confirm:disabled {
  background: #d3e1ed;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-mapping-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 8px 0;
  text-align: left;
}

.add-mapping-modal-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 24px 0;
  text-align: left;
}

.add-mapping-modal-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
}

.add-mapping-modal-label {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #142a31;
}
.add-mapping-modal-label .required {
  color: #ef4444;
  margin-left: 2px;
}

.add-mapping-modal-input {
  padding: 10px 12px;
  border: 1px solid #d3e1ed;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #142a31;
  outline: none;
  transition: border-color 0.2s;
}
.add-mapping-modal-input:focus {
  border-color: #40a0c1;
}
.add-mapping-modal-input.error {
  border-color: #ef4444;
}
.add-mapping-modal-input::placeholder {
  color: #88abb4;
}

.add-mapping-modal-error {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #ef4444;
  margin-top: -4px;
}

.add-mapping-modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.add-mapping-modal-cancel {
  padding: 8px 29px;
  background: transparent;
  color: #142a31;
  border: 1px solid #d3e1ed;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.add-mapping-modal-cancel:hover {
  background: #f5f9ff;
}

.add-mapping-modal-confirm {
  padding: 8px 29px;
  background: #40a0c1;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.add-mapping-modal-confirm:hover:not(:disabled) {
  background: #338ba8;
}
.add-mapping-modal-confirm:disabled {
  background: #d3e1ed;
  cursor: not-allowed;
  opacity: 0.6;
}

.delete-mapping-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 20px 0;
}

.delete-mapping-modal-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 30px 0;
  max-width: 300px;
}

.delete-mapping-modal-buttons {
  display: flex;
  gap: 12px;
}

.delete-mapping-modal-cancel {
  padding: 8px 29px;
  background: transparent;
  color: #142a31;
  border: 1px solid #d3e1ed;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.delete-mapping-modal-cancel:hover {
  background: #f5f9ff;
}

.delete-mapping-modal-confirm {
  padding: 8px 29px;
  background: #ef4444;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.delete-mapping-modal-confirm:hover {
  background: #dc2626;
}

/* Custom dropdown for Opportunity Field (Deals -> properties) */
.custom-dropdown-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.custom-dropdown-trigger {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #cdd6da;
  border-radius: 5px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.custom-dropdown-trigger .dropdown-label {
  font-size: 11px;
  color: #062229;
}

.custom-dropdown-trigger .dropdown-arrow {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #706e6b;
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 210px;
  background: #fff;
  border: 1px solid #dfe6e9;
  border-radius: 8px;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);
  z-index: 20;
}

.custom-dropdown-menu-scroll {
  max-height: 320px;
  overflow: auto;
}

.custom-dropdown-item {
  padding: 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
  font-size: 11px;
  color: #062229;
}

.custom-dropdown-item:last-child {
  border-bottom: none;
}

.custom-dropdown-item.selected {
  background: #f5f9ff;
  font-weight: 600;
}

.custom-dropdown-item:hover {
  background: #f5f9ff;
}

.custom-dropdown-item .submenu-arrow {
  font-size: 12px;
  color: #6a8991;
}

.custom-dropdown-item .item-label {
  flex: 1 1;
}

.custom-dropdown-item .item-type {
  font-size: 12px;
  color: #706e6b;
  margin-left: 8px;
}

.custom-dropdown-item.has-submenu {
  padding-right: 2px;
}

.custom-dropdown-submenu {
  position: fixed;
  background: #fff;
  border: 1px solid #dfe6e9;
  border-radius: 8px;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);
  width: 280px;
  z-index: 25;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.submenu-search-container {
  padding: 8px 10px 6px 10px;
  border-bottom: 1px solid #ecf0f1;
}

.submenu-search-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #dfe6e9;
  border-radius: 6px;
  font-size: 11px;
  box-sizing: border-box;
}

.submenu-items-container {
  max-height: 300px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.custom-dropdown-submenu-item {
  padding: 11px 12px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}

.custom-dropdown-submenu-item:last-child {
  border-bottom: none;
}

.custom-dropdown-submenu-item:hover {
  background: #f5f9ff;
}

.submenu-item-label {
  font-size: 11px;
  color: #062229;
}

.submenu-item-type {
  font-size: 11.5px;
  color: #6a8991;
}

.no-results-message {
  padding: 12px;
  text-align: center;
  color: #6a8991;
  font-size: 11px;
  font-style: italic;
}

@media (max-width: 768px) {
  .hubspot-header {
    flex-direction: column;
    gap: 16px;
  }
  .hubspot-info-section {
    flex-direction: column;
    gap: 20px;
  }
  .hubspot-tabs {
    overflow-x: auto;
  }
  .mapping-profile-tabs {
    flex-direction: column;
    align-items: flex-start;
  }
  .profile-user-list {
    width: 100%;
    justify-content: flex-start;
  }
  .field-name-row {
    max-width: 100%;
  }
  .field-row {
    grid-template-columns: 1fr;
  }
  .mapping-table-subheader,
  .mapping-table-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .section-filters {
    flex-direction: column;
    width: 100%;
  }
  .automation-indicator-bar {
    margin-left: 24px;
  }
  .automation-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 24px;
  }
  .toggle-switch {
    width: 100%;
  }
  .automation-input {
    width: 100%;
  }
  .automation-triggers-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .trigger-card {
    max-width: 100%;
  }
  .trigger-card-footer {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .trigger-actions {
    flex-wrap: wrap;
  }
}
.create-trigger-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.create-trigger-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0;
}

.trigger-form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trigger-form-label {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.21;
  color: #142a31;
}

.trigger-name-input {
  width: 447px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #365a64;
  outline: none;
  box-sizing: border-box;
}
.trigger-name-input::placeholder {
  color: #365a64;
}

.trigger-status-section {
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 8px 0;
}

.trigger-checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.trigger-checkbox-label {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
}

.trigger-rules-container {
  background: rgba(255, 255, 255, 0);
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 12px;
  min-height: 95px;
  max-height: 300px;
  overflow-y: auto;
}

.trigger-modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
}

.trigger-modal-cancel {
  padding: 8px 29px;
  background: #142b31;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.trigger-modal-cancel:hover {
  background: #1f3d47;
}

.trigger-modal-save {
  padding: 8px 29px;
  background: #40a0c1;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.trigger-modal-save:hover {
  background: #3589a8;
}

.connect-to-ace-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.connect-to-ace-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0;
}

.connect-to-ace-form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.connect-to-ace-form-label {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.21;
  color: #142a31;
}

.connect-to-ace-name-input {
  width: 447px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #365a64;
  outline: none;
  box-sizing: border-box;
}
.connect-to-ace-name-input::placeholder {
  color: #365a64;
}

.connect-to-ace-name-select {
  width: 447px;
  height: 35px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #365a64;
  outline: none;
  box-sizing: border-box;
}
.connect-to-ace-name-select::placeholder {
  color: #365a64;
}

.connect-to-ace-modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
}

.connect-to-ace-modal-cancel {
  padding: 8px 29px;
  background: #142b31;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.connect-to-ace-modal-cancel:hover {
  background: #1f3d47;
}

.connect-to-ace-modal-save {
  padding: 8px 29px;
  background: #40a0c1;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.connect-to-ace-modal-save:hover {
  background: #3589a8;
}
.connect-to-ace-modal-save:disabled {
  background: #a0cbd9;
  cursor: not-allowed;
}

.connect-to-ace-form-required {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.21;
  color: #d14343;
}

.mapping-tab-wrapper {
  padding: 20px;
  background: #ffffff;
}

.field-dropdown-wrapper {
  position: relative;
  width: 100%;
}

.custom-dropdown-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 32px 6px 10px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #365a64;
  min-height: 31px;
  height: 42px;
  position: relative;
  box-sizing: border-box;
}
.custom-dropdown-display:hover {
  border-color: #40a0c1;
}
.custom-dropdown-display span {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-icon-inline {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  flex-shrink: 0;
  pointer-events: none;
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 100%;
  width: max-content;
  max-width: 600px;
}

.custom-dropdown-search {
  padding: 8px 8px 8px 8px;
  border-bottom: 1px solid #e0e6eb;
  flex-shrink: 0;
  background: #ffffff;
}

.dropdown-search-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #365a64;
  outline: none;
  box-sizing: border-box;
}
.dropdown-search-input:focus {
  border-color: #40a0c1;
}
.dropdown-search-input::placeholder {
  color: #9ba7af;
}

.custom-dropdown-options {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: visible;
  min-width: max-content;
  width: auto;
}
.custom-dropdown-options::-webkit-scrollbar {
  width: 8px;
}
.custom-dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.custom-dropdown-options::-webkit-scrollbar-thumb {
  background: #d3e1ed;
  border-radius: 4px;
}
.custom-dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #40a0c1;
}

.custom-dropdown-option {
  padding: 8px 8px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #365a64;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  transition: background 0.15s;
  overflow: visible !important;
  min-height: 32px;
  gap: 16px;
  white-space: nowrap;
}
.custom-dropdown-option:hover {
  background: #f5f9ff;
}
.custom-dropdown-option.has-submenu {
  padding-right: 32px;
  overflow: visible !important;
}
.custom-dropdown-option > span:first-child {
  flex: 1 1;
  white-space: nowrap;
}

.field-type-label {
  color: #706e6b;
  font-size: 11px;
  margin-left: auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.submenu-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.custom-dropdown-submenu {
  position: fixed;
  min-width: 280px;
  max-width: 350px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);
  z-index: 10000 !important;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

.submenu-option {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  transition: background 0.15s;
  min-height: auto;
}
.submenu-option:hover {
  background: #f5f9ff;
}

.submenu-option-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
}

.submenu-option-label {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #365a64;
  font-weight: 500;
  line-height: 1.3;
}

.submenu-option-type {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  color: #706e6b;
  line-height: 1.2;
}

.mapping-table {
  overflow: visible !important;
}

.mapping-table-row td {
  overflow: visible !important;
}

.mapping-cell {
  overflow: visible !important;
  position: relative;
}

.opportunity-field-select-container {
  position: relative;
  width: 100%;
}

.custom-dropdown {
  position: relative;
  width: 100%;
  height: 100%;
}

.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 32px 6px 10px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #365a64;
  height: 42px;
  position: relative;
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
}
.dropdown-header:hover {
  border-color: #40a0c1;
}

.dropdown-text {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.dropdown-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
}
.dropdown-arrow.open {
  transform: translateY(-50%) rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  min-width: max(100%, 215px);
  width: max-content;
  max-width: 600px;
  box-sizing: border-box;
  overflow: hidden;
}

.dropdown-search {
  padding: 8px;
  border-bottom: 1px solid #e0e6eb;
  flex-shrink: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-search-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #365a64;
  outline: none;
  box-sizing: border-box;
}
.dropdown-search-input:focus {
  border-color: #40a0c1;
}
.dropdown-search-input::placeholder {
  color: #9ba7af;
}

.dropdown-options {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: visible;
  width: auto;
}
.dropdown-options::-webkit-scrollbar {
  width: 6px;
}
.dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.dropdown-options::-webkit-scrollbar-thumb {
  background: #d3e1ed;
  border-radius: 4px;
}
.dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #40a0c1;
}

.dropdown-option {
  padding: 8px 12px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #365a64;
  display: flex;
  align-items: center;
  transition: background 0.15s;
  white-space: nowrap;
}
.dropdown-option:hover {
  background: #f5f9ff;
}
.dropdown-option.selected {
  background: #e8f4f8;
  font-weight: 500;
}
.dropdown-option.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.option-label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.default-value-cell {
  overflow: visible !important;
}
.default-value-cell .field-name-input-container {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/HubspotIntegration/hubspot-integration.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,8BAAA;AACF;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEE;EACE,YAAA;AAAJ;;AAIA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AADF;;AAIA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAKA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8FAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AALJ;;AAUA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AAPF;;AAUA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAPF;AASE;EACE,gBAAA;EACA,cAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAPN;AAWE;EACE,YAAA;AATJ;;AAaA;EACE,WAAA;EACA,YAAA;AAVF;;AAcA;EACE,mBAAA;EACA,iBAAA;AAXF;;AAcA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AAXF;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZF;;AAeA;EACE,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAZF;;AAeA;EACE,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAZF;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;AAbJ;AAgBE;EACE,cAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAhBF;AAkBE;EACE,cAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AAjBF;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,YAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAnBF;AAqBE;EACE,mCAAA;EACA,cAAA;AAnBJ;AAsBE;EACE,qCAAA;EACA,cAAA;AApBJ;;AAwBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,cAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArBF;;AAwBA;EACE,eAAA;EACA,oBAAA;AArBF;AAuBE;EAEE,WAAA;EACA,YAAA;EAEA,0HAAA;AAvBJ;AA8BE;EACE,YAAA;AA5BJ;;AAgCA;EACE,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AA7BF;AA+BE;EACE,YAAA;AA7BJ;;AAiCA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;AA9BF;;AAkCA;EACE,aAAA;EACA,qBAAA;EACA,MAAA;AA/BF;;AAkCA;EACE,kBAAA;AA/BF;;AAkCA;EACE,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA/BF;AAiCE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;AA/BJ;;AAmCA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AAhCF;;AAmCA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AAhCF;;AAmCA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAhCF;AAkCE;EACE,YAAA;AAhCJ;;AAoCA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCF;AAmCE;EACE,YAAA;AAjCJ;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,mBAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAnCF;;AAwCA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AArCF;;AAwCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;AArCF;AAuCE;EACE,qBAAA;AArCJ;AAwCE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AAxCJ;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AA1CF;AA4CE;EACE,cAAA;AA1CJ;;AA8CA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AA3CF;;AA8CA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA3CF;AA6CE;EACE,YAAA;AA3CJ;;AAgDA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA7CF;AA+CE;EACE,mBAAA;AA7CJ;;AAiDA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AA9CF;AAgDE;EACE,cAAA;AA9CJ;;AAkDA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA/CF;AAiDE;EACE,YAAA;AA/CJ;;AAmDA;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;AAhDF;;AAmDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAhDF;;AAmDA;EACE,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAhDF;AAkDE;EACE,uBAAA;AAhDJ;;AAoDA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAjDF;;AAoDA;EACE,2BAAA;AAjDF;;AAoDA;EACE,wBAAA;AAjDF;;AAoDA;EACE,kBAAA;AAjDF;;AAoDA;;EAEE,mBAAA;AAjDF;;AAoDA;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;AAjDF;;AAoDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,4BAAA;AAjDF;AAmDE;EAEE,UAAA;AAlDJ;AAqDE;EACE,UAAA;AAnDJ;AAsDE;EACE,SAAA;AApDJ;AAuDE;EACE,UAAA;AArDJ;AAwDE;EACE,UAAA;AAtDJ;;AA0DA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvDF;AAyDE;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;AAvDJ;;AA2DA;EACE,mBAAA;EACA,gBAAA;AAxDF;AA0DE;EACE,mBAAA;AAxDJ;;AA4DA;EACE,kBAAA;AAzDF;AA2DE;EACE,kBAAA;AAzDJ;;AA6DA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA1DF;;AA6DA;EAIE,cAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AA7DF;;AAgEA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AA7DF;AA+DE;EACE,gBAAA;AA7DJ;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA9DF;AAgEE;EACE,cAAA;EACA,qBAAA;AA9DJ;AAgEI;EACE,0BAAA;AA9DN;;AAmEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAhEF;;AAmEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAhEF;;AAmEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AAhEF;;AAmEA;EACE,eAAA;AAhEF;AAkEE;EACE,YAAA;AAhEJ;;AAoEA;EACE,cAAA;AAjEF;;AAoEA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;AAjEF;AAmEE;EACE,mBAAA;AAjEJ;;AAsEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,SAAA;AAnEF;;AAsEA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAnEF;AAqEE;EACE,mBAAA;AAnEJ;;AAuEA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AApEF;AAsEE;EACE,mBAAA;AApEJ;;AAyEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAtEF;;AAyEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAtEF;AAwEE;EACE,gBAAA;EACA,cAAA;AAtEJ;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAvEF;;AA0EA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvEF;AAyEE;EACE,cAAA;EACA,gBAAA;AAvEJ;;AA2EA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;AAxEF;AA0EE;EACE,qBAAA;AAxEJ;AA2EE;EACE,qBAAA;AAzEJ;AA4EE;EACE,cAAA;AA1EJ;;AA8EA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AA3EF;AA6EE;EACE,mBAAA;AA3EJ;;AA+EA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AA5EF;AA8EE;EACE,mBAAA;AA5EJ;AA+EE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA7EJ;;AAkFA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA/EF;;AAkFA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA/EF;;AAkFA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA/EF;AAiFE;EACE,cAAA;EACA,gBAAA;AA/EJ;;AAmFA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;AAhFF;AAkFE;EACE,qBAAA;AAhFJ;AAmFE;EACE,qBAAA;AAjFJ;AAoFE;EACE,cAAA;AAlFJ;;AAsFA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAnFF;;AAsFA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AAnFF;;AAsFA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAnFF;AAqFE;EACE,mBAAA;AAnFJ;;AAuFA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AApFF;AAsFE;EACE,mBAAA;AApFJ;AAuFE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AArFJ;;AA0FA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAvFF;;AA0FA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAvFF;;AA0FA;EACE,aAAA;EACA,SAAA;AAvFF;;AA0FA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAvFF;AAyFE;EACE,mBAAA;AAvFJ;;AA2FA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAxFF;AA0FE;EACE,mBAAA;AAxFJ;;AA4FA,gEAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,WAAA;AAzFF;;AA4FA;EACE,iBAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;;AA4FA;EACE,mBAAA;EACA,gBAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,SAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzFF;;AA4FA;EACE,kBAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAzFF;;AA4FA;EACE,0BAAA;EACA,gCAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAzFF;;AA4FA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,iBAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAzFF;;AA6FA;EACE;IACE,sBAAA;IACA,SAAA;EA1FF;EA6FA;IACE,sBAAA;IACA,SAAA;EA3FF;EA8FA;IACE,gBAAA;EA5FF;EA+FA;IACE,sBAAA;IAEA,uBAAA;EA9FF;EAiGA;IACE,WAAA;IACA,2BAAA;EA/FF;EAkGA;IACE,eAAA;EAhGF;EAmGA;IACE,0BAAA;EAjGF;EAoGA;;IAEE,0BAAA;IACA,QAAA;EAlGF;EAqGA;IACE,sBAAA;IACA,WAAA;EAnGF;EAsGA;IACE,iBAAA;EApGF;EAuGA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;EArGF;EAwGA;IACE,WAAA;EAtGF;EAyGA;IACE,WAAA;EAvGF;EA0GA;IACE,sBAAA;IACA,SAAA;IACA,uBAAA;EAxGF;EA2GA;IACE,eAAA;EAzGF;EA4GA;IACE,sBAAA;IACA,SAAA;IACA,uBAAA;EA1GF;EA6GA;IACE,eAAA;EA3GF;AACF;AA+GA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7GF;;AAgHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA7GF;;AAgHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7GF;;AAgHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7GF;;AAgHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AA7GF;AA+GE;EACE,cAAA;AA7GJ;;AAiHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AA9GF;;AAiHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9GF;;AAiHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9GF;;AAiHA;EACE,kCAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA9GF;;AAiHA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AA9GF;;AAiHA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AA9GF;AAgHE;EACE,mBAAA;AA9GJ;;AAkHA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AA/GF;AAiHE;EACE,mBAAA;AA/GJ;;AAoHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjHF;;AAoHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAjHF;;AAoHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjHF;;AAoHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjHF;;AAoHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAjHF;AAmHE;EACE,cAAA;AAjHJ;;AAqHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAlHF;AAoHE;EACE,cAAA;AAlHJ;;AAsHA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AAnHF;;AAsHA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAnHF;AAqHE;EACE,mBAAA;AAnHJ;;AAuHA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AApHF;AAsHE;EACE,mBAAA;AApHJ;AAuHE;EACE,mBAAA;EACA,mBAAA;AArHJ;;AAyHA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtHF;;AA0HA;EACE,aAAA;EACA,mBAAA;AAvHF;;AA2HA;EACE,kBAAA;EACA,WAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAxHF;AA0HE;EACE,qBAAA;AAxHJ;AA2HE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzHJ;;AA6HA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,oBAAA;AA1HF;;AA6HA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA1HF;;AA6HA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;AA1HF;;AA6HA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AA1HF;AA4HE;EACE,qBAAA;AA1HJ;AA6HE;EACE,cAAA;AA3HJ;;AA+HA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AA5HF;AA8HE;EACE,UAAA;AA5HJ;AA+HE;EACE,mBAAA;EACA,kBAAA;AA7HJ;AAgIE;EACE,mBAAA;EACA,kBAAA;AA9HJ;AAgII;EACE,mBAAA;AA9HN;;AAmIA;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,4BAAA;EACA,4BAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAhIF;AAkIE;EACE,mBAAA;AAhIJ;AAmIE;EACE,mBAAA;EACA,4BAAA;AAjIJ;AAoIE;EACE,SAAA;EACA,mBAAA;AAlIJ;;AAsIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAnIF;;AAsIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAnIF;;AAsIA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;EACA,gBAAA;AAnIF;AAqIE;EACE,mBAAA;AAnIJ;;AAuIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;AApIF;;AAuIA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AApIF;;AAuIA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AApIF;;AAwIA;EACE,4BAAA;AArIF;;AAwIA;EACE,4BAAA;AArIF;;AAwIA;EACE,4BAAA;EACA,kBAAA;AArIF;;AAwIA;EACE,kBAAA;EACA,WAAA;AArIF;;AAyIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAtIF;;AAyIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAtIF;AAwIE;EACE,qBAAA;AAtIJ;;AA0IA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAvIF;;AA0IA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;AAvIF;AAyIE;EACE,0CAAA;AAvIJ;;AA2IA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAxIF;;AA2IA;EACE,YAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAxIF;;AA2IA;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAxIF;AA0IE;EACE,qBAAA;AAxIJ;AA2IE;EACE,cAAA;AAzIJ;;AA6IA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA1IF;AA4IE;EACE,UAAA;AA1IJ;AA6IE;EACE,mBAAA;EACA,kBAAA;AA3IJ;AA8IE;EACE,mBAAA;EACA,kBAAA;AA5IJ;AA8II;EACE,mBAAA;AA5IN;;AAiJA;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AA9IF;AAgJE;EACE,mBAAA;AA9IJ;AAiJE;EACE,mBAAA;EACA,gBAAA;AA/IJ;AAkJE;EACE,mBAAA;EACA,YAAA;AAhJJ;;AAoJA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjJF;;AAqJA;EACE,4BAAA;AAlJF;AAoJE;EACE,4BAAA;AAlJJ","sourcesContent":[".hubspot-integration-container {\n  background: #ffffff;\n  min-height: calc(100vh - 64px);\n}\n\n// Header\n.hubspot-header {\n  background: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-bottom: 1px solid #d3e1ed;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hubspot-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.back-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.breadcrumb {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #40a0c1;\n  margin-bottom: 0;\n}\n\n.breadcrumb-separator {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #142a31;\n  margin: 0 8px;\n}\n\n.breadcrumb-current {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #142a31;\n}\n\n// Integration Info Section\n.hubspot-info-section {\n  padding: 30px 24px;\n  background: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.hubspot-info-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hubspot-title-group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 55.68px;\n}\n\n.hubspot-logo-wrapper {\n  width: 55.68px;\n  height: 55.68px;\n  border-radius: 50%;\n  box-shadow: 0px 9px 13px 0px rgba(129, 155, 163, 0.12),\n    0px 0px 3px 0px rgba(20, 43, 49, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.hubspot-logo {\n  width: 34px;\n  height: 34px;\n  object-fit: contain;\n}\n\n.hubspot-info-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-left: calc(55.68px + 20px);\n}\n\n.hubspot-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0;\n}\n\n.hubspot-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0;\n  max-width: 428px;\n}\n\n.hubspot-expiry {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.hubspot-expiry-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0;\n}\n\n.hubspot-expiry-date {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0;\n}\n\n.hubspot-info-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.disconnect-button {\n  padding: 7px 11px;\n  background: #142a31;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n.connect-to-ace-button {\n  padding: 7px 11px;\n  background: #40a0c1;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #2c83a0;\n  }\n\n  & img {\n    width: 21px;\n    height: 21px;\n    margin-right: 8px;\n  }\n}\n\n// Tabs\n.hubspot-tabs {\n  display: flex;\n  gap: 24px;\n  padding: 0 24px;\n  border-bottom: 1px solid #d3e1ed;\n  background: #ffffff;\n}\n\n.hubspot-tab {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #062229;\n  background: transparent;\n  border: none;\n  padding: 12px 0;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  &.active {\n    font-weight: 700;\n    color: #062229;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      right: 0;\n      height: 3px;\n      background: #40a0c1;\n      border-radius: 0;\n    }\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.delete-icon {\n  width: 16px;\n  height: 16px;\n}\n\n// Automation & Alerts Content\n.automation-alerts-content {\n  background: #ffffff;\n  min-height: 400px;\n}\n\n.automation-indicator-bar {\n  width: 141px;\n  height: 5px;\n  background: #40a0c1;\n  border-radius: 7px;\n  margin-left: 101px;\n  margin-bottom: 8px;\n}\n\n.automation-section-title {\n  background: #f5f9ff;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #6a8991;\n  padding: 12px 24px;\n  border-bottom: 1px solid #d3e1ed;\n}\n\n.automation-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 24px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #d3e1ed;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.automation-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #6a8991;\n}\n\n.toggle-switch {\n  display: flex;\n  border: 0.64px solid #e5edef;\n  border-radius: 3.83px;\n  overflow: hidden;\n  background: #ffffff;\n  width: 86px;\n  height: 29.37px;\n  position: relative;\n}\n\n.toggle-option {\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #000000;\n  background: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n\n  span {\n    display: block;\n  }\n\n  &.selected {\n    background: #40a0c1;\n    font-weight: 700;\n    color: #ffffff;\n    border-radius: 3.83px 0 0 3.83px;\n    width: 42.14px;\n  }\n\n  &:not(.selected) {\n    color: #000000;\n    font-weight: 400;\n  }\n\n  &:hover:not(.selected) {\n    background: #f5f9ff;\n  }\n}\n\n.automation-input {\n  width: 86px;\n  height: 31px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #062229;\n  outline: none;\n  box-sizing: border-box;\n  margin-left: 24px;\n\n  &::placeholder {\n    color: #6a8991;\n  }\n}\n\n.automation-triggers-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n}\n\n.trigger-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  background: #40a0c1;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #3690b1;\n  }\n\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n}\n\n.trigger-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0px 24px 36px 24px;\n}\n\n.trigger-card {\n  background: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-bottom: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 16px 24px;\n  max-width: 624px;\n}\n\n.trigger-card-header {\n  margin-bottom: 12px;\n}\n\n.trigger-card-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.trigger-name {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #062229;\n}\n\n.trigger-status {\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1.21;\n\n  &.active {\n    background: rgba(64, 160, 193, 0.2);\n    color: #40a0c1;\n  }\n\n  &.inactive {\n    background: rgba(106, 137, 145, 0.19);\n    color: #6a8991;\n  }\n}\n\n.trigger-card-content {\n  background: #ffffff;\n  border: 1px solid #e0e6eb;\n  border-radius: 4px;\n  padding: 10px;\n  margin-bottom: 12px;\n}\n\n.trigger-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 1.21;\n  color: #062229;\n  margin: 0;\n}\n\n.trigger-card-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.trigger-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #6a8991;\n}\n\n.trigger-separator {\n  color: #d3e1ed;\n}\n\n.trigger-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.trigger-action-icon {\n  cursor: pointer;\n  transition: all 0.2s;\n  \n  &.edit-icon,\n  &.delete-icon {\n    width: 12px;\n    height: 12px;\n    // Filter to change icon color from original to #6A8991\n    filter: brightness(0) saturate(100%) invert(59%) sepia(8%) saturate(959%) hue-rotate(143deg) brightness(91%) contrast(90%);\n  }\n  \n  &.close-icon {\n    // SVG icon, style handled inline\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.trigger-action-link {\n  background: transparent;\n  border: none;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.21;\n  color: #6a8991;\n  cursor: pointer;\n  padding: 0;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.profile-indicator {\n  width: 66px;\n  height: 5px;\n  background: #40a0c1;\n  border-radius: 7px;\n}\n\n.mapping-profile-tabs {\n  display: flex;\n  align-items: flex-start;\n  // gap: 12px;\n}\n\n.profile-tabs-list {\n  display: flex;\n  align-items: flex-end;\n  gap: 0;\n}\n\n.profile-tab-container {\n  position: relative;\n}\n\n.profile-tab {\n  background: #f5f9ff;\n  border: none;\n  border-radius: 5px 5px 0 0;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n\n  &.active {\n    background: #ffffff;\n    border: 1px solid #dbe7f1;\n    border-bottom: none;\n  }\n}\n\n.profile-tab-divider {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 14px;\n  border-right: 1px solid #d3e1ed;\n}\n\n.profile-tab-text {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #6a8991;\n}\n\n.profile-tab-border {\n  background: #ffffff;\n  height: 3px;\n  width: 100%;\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n}\n\n.profile-user-list {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 4px;\n  margin-left: auto;\n}\n\n.profile-user {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #6a8991;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.profile-separator {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #d3e1ed;\n}\n\n.profile-add-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.section-header-simple {\n  margin-bottom: 16px;\n}\n\n.section-indicator {\n  width: 51px;\n  height: 5px;\n  background: #40a0c1;\n  border-radius: 7px;\n}\n\n// section-title moved to mapping-tab.scss\n\n.section-filters {\n  display: flex;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.filter-dropdown {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  height: 34px;\n  color: #142a31;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    border-color: #94a3b8;\n  }\n\n  span {\n    color: #142a31;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n\n  select {\n    border: none;\n    background: transparent;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n    color: #142a31;\n    cursor: pointer;\n    outline: none;\n    appearance: none;\n    padding-right: 16px;\n  }\n\n  .dropdown-icon {\n    position: absolute;\n    right: 14px;\n    pointer-events: none;\n  }\n}\n\n// Field Name Wrapper\n.field-name-wrapper {\n  margin-top: 16px;\n}\n\n.field-name-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  max-width: 280px;\n}\n\n.field-name-input-container {\n  position: relative;\n  height: 31px;\n}\n\n.field-name-input {\n  width: 100%;\n  height: 42px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  color: #062229;\n  outline: none;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: #6a8991;\n  }\n}\n\n.field-name-dropdown-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.field-add-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n// Field Rows\n.field-row {\n  display: grid;\n  grid-template-columns: 120px 1fr auto;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n  position: relative;\n\n  &.field-row-last {\n    margin-bottom: 32px;\n  }\n}\n\n.field-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #6a8991;\n}\n\n.field-input {\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #062229;\n  outline: none;\n\n  &::placeholder {\n    color: #6a8991;\n  }\n}\n\n.field-select {\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #062229;\n  outline: none;\n  appearance: none;\n  cursor: pointer;\n}\n\n.dropdown-icon-field {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.dropdown-icon-select {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.field-actions {\n  display: flex;\n  gap: 8px;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.mapping-table-header-row {\n  background: #fbfcff;\n  border: 1px solid #e0e6eb;\n  border-bottom: 1px solid #d3e1ed;\n}\n\n.mapping-table-header-cell {\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #6a8991;\n  background-color: #fbfcff;\n}\n\n.expand-icon {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  transform: rotate(180deg);\n  margin-right: 12px;\n  margin-bottom: 2px;\n\n  &.expanded {\n    transform: rotate(0deg);\n  }\n}\n\n.mapping-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  display: table;\n  border: none;\n}\n\n.mapping-table thead {\n  display: table-header-group;\n}\n\n.mapping-table tbody {\n  display: table-row-group;\n}\n\n.mapping-table tr {\n  display: table-row;\n}\n\n.mapping-table th,\n.mapping-table td {\n  display: table-cell;\n}\n\n.mapping-table-subheader {\n  background: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-bottom: 1px solid #d3e1ed;\n}\n\n.mapping-table-subheader th {\n  padding: 12px 10px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n  letter-spacing: 0 !important;\n\n  &:nth-child(1),\n  &:nth-child(2) {\n    width: 20%;\n  }\n\n  &:nth-child(3) {\n    width: 25%;\n  }\n\n  &:nth-child(4) {\n    width: 8%;\n  }\n\n  &:nth-child(5) {\n    width: 12%;\n  }\n\n  &:nth-child(6) {\n    width: 20%;\n  }\n}\n\n.mapping-column-header {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #6a8991;\n\n  &.mapped-header {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.mapping-table-row {\n  background: #ffffff;\n  border-top: none;\n\n  &:nth-child(even) {\n    background: #f5f9ff;\n  }\n}\n\n.mapping-table-row td {\n  padding: 10px 10px;\n\n  &:last-child {\n    border-right: none;\n  }\n}\n\n.mapping-cell {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #142a31;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  min-width: 0;\n  max-width: 100%;\n  overflow: visible;\n}\n\n.mapping-cell-text {\n  // white-space: nowrap;\n  // overflow: hidden;\n  // text-overflow: ellipsis;\n  display: block;\n  max-width: 100%;\n  flex: 1;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.mapped-cell {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  overflow: visible !important;\n}\n\n.opportunity-field-select-container {\n  position: relative;\n  width: 100%;\n  min-height: 31px;\n\n  &.has-hint .field-dropdown-wrapper {\n    margin-top: 20px;\n  }\n}\n\n.mapping-table-row:not(.has-hint-row) td {\n  padding-top: 20px;\n}\n\n.field-hint {\n  font-size: 11px;\n  color: #706e6b;\n  margin-top: 4px;\n  font-style: italic;\n  line-height: 1.4;\n  font-weight: 400;\n\n  a {\n    color: #0176d3;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.opportunity-select {\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 32px 8px 10px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #142a31;\n  outline: none;\n  appearance: none;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.mapping-select {\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 0px 20px 0px 6px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #062229;\n  outline: none;\n  appearance: none;\n  cursor: pointer;\n  flex: 1;\n}\n\n.dropdown-icon-inline {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.edit-icon {\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.default-value-cell {\n  color: #88abb4;\n}\n\n.map-values-button {\n  padding: 7px 11px;\n  background: #142a31;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n  height: 40px;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n// Disconnect Modal\n.disconnect-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 20px 0;\n}\n\n.disconnect-modal-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 30px 0;\n  max-width: 300px;\n}\n\n.disconnect-modal-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.disconnect-modal-cancel {\n  padding: 8px 29px;\n  background: transparent;\n  color: #142a31;\n  border: 1px solid #d3e1ed;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n}\n\n.disconnect-modal-confirm {\n  padding: 8px 29px;\n  background: #142a31;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n// Duplicate Mapping Modal\n.duplicate-mapping-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 8px 0;\n  text-align: left;\n}\n\n.duplicate-mapping-modal-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 24px 0;\n  text-align: left;\n\n  strong {\n    font-weight: 600;\n    color: #142a31;\n  }\n}\n\n.duplicate-mapping-modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 30px;\n}\n\n.duplicate-mapping-modal-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #142a31;\n\n  .required {\n    color: #ef4444;\n    margin-left: 2px;\n  }\n}\n\n.duplicate-mapping-modal-input {\n  padding: 10px 12px;\n  border: 1px solid #d3e1ed;\n  border-radius: 6px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #142a31;\n  outline: none;\n  transition: border-color 0.2s;\n\n  &:focus {\n    border-color: #40a0c1;\n  }\n\n  &.error {\n    border-color: #ef4444;\n  }\n\n  &::placeholder {\n    color: #88abb4;\n  }\n}\n\n.duplicate-mapping-modal-error {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #ef4444;\n  margin-top: -4px;\n}\n\n.duplicate-mapping-modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.duplicate-mapping-modal-cancel {\n  padding: 8px 29px;\n  background: transparent;\n  color: #142a31;\n  border: 1px solid #d3e1ed;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n}\n\n.duplicate-mapping-modal-confirm {\n  padding: 8px 29px;\n  background: #40a0c1;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover:not(:disabled) {\n    background: #338ba8;\n  }\n\n  &:disabled {\n    background: #d3e1ed;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n// Add Mapping Modal (same styles as Duplicate)\n.add-mapping-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 8px 0;\n  text-align: left;\n}\n\n.add-mapping-modal-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 24px 0;\n  text-align: left;\n}\n\n.add-mapping-modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 30px;\n}\n\n.add-mapping-modal-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #142a31;\n\n  .required {\n    color: #ef4444;\n    margin-left: 2px;\n  }\n}\n\n.add-mapping-modal-input {\n  padding: 10px 12px;\n  border: 1px solid #d3e1ed;\n  border-radius: 6px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #142a31;\n  outline: none;\n  transition: border-color 0.2s;\n\n  &:focus {\n    border-color: #40a0c1;\n  }\n\n  &.error {\n    border-color: #ef4444;\n  }\n\n  &::placeholder {\n    color: #88abb4;\n  }\n}\n\n.add-mapping-modal-error {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #ef4444;\n  margin-top: -4px;\n}\n\n.add-mapping-modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.add-mapping-modal-cancel {\n  padding: 8px 29px;\n  background: transparent;\n  color: #142a31;\n  border: 1px solid #d3e1ed;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n}\n\n.add-mapping-modal-confirm {\n  padding: 8px 29px;\n  background: #40a0c1;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover:not(:disabled) {\n    background: #338ba8;\n  }\n\n  &:disabled {\n    background: #d3e1ed;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n// Delete Mapping Modal\n.delete-mapping-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 20px 0;\n}\n\n.delete-mapping-modal-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 30px 0;\n  max-width: 300px;\n}\n\n.delete-mapping-modal-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.delete-mapping-modal-cancel {\n  padding: 8px 29px;\n  background: transparent;\n  color: #142a31;\n  border: 1px solid #d3e1ed;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n}\n\n.delete-mapping-modal-confirm {\n  padding: 8px 29px;\n  background: #ef4444;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #dc2626;\n  }\n}\n\n/* Custom dropdown for Opportunity Field (Deals -> properties) */\n.custom-dropdown-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.custom-dropdown-trigger {\n  width: 100%;\n  padding: 6px 10px;\n  border: 1px solid #cdd6da;\n  border-radius: 5px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.custom-dropdown-trigger .dropdown-label {\n  font-size: 11px;\n  color: #062229;\n}\n\n.custom-dropdown-trigger .dropdown-arrow {\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 5px solid #706e6b;\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 210px;\n  background: #fff;\n  border: 1px solid #dfe6e9;\n  border-radius: 8px;\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);\n  z-index: 20;\n}\n\n.custom-dropdown-menu-scroll {\n  max-height: 320px;\n  overflow: auto;\n}\n\n.custom-dropdown-item {\n  padding: 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border-bottom: 1px solid #f1f1f1;\n  font-size: 11px;\n  color: #062229;\n}\n\n.custom-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.custom-dropdown-item.selected {\n  background: #f5f9ff;\n  font-weight: 600;\n}\n\n.custom-dropdown-item:hover {\n  background: #f5f9ff;\n}\n\n.custom-dropdown-item .submenu-arrow {\n  font-size: 12px;\n  color: #6a8991;\n}\n\n.custom-dropdown-item .item-label {\n  flex: 1;\n}\n\n.custom-dropdown-item .item-type {\n  font-size: 12px;\n  color: #706e6b;\n  margin-left: 8px;\n}\n\n.custom-dropdown-item.has-submenu {\n  padding-right: 2px;\n}\n\n.custom-dropdown-submenu {\n  position: fixed;\n  background: #fff;\n  border: 1px solid #dfe6e9;\n  border-radius: 8px;\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);\n  width: 280px;\n  z-index: 25;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.submenu-search-container {\n  padding: 8px 10px 6px 10px;\n  border-bottom: 1px solid #ecf0f1;\n}\n\n.submenu-search-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #dfe6e9;\n  border-radius: 6px;\n  font-size: 11px;\n  box-sizing: border-box;\n}\n\n.submenu-items-container {\n  max-height: 300px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-dropdown-submenu-item {\n  padding: 11px 12px;\n  border-bottom: 1px solid #f1f1f1;\n  cursor: pointer;\n}\n\n.custom-dropdown-submenu-item:last-child {\n  border-bottom: none;\n}\n\n.custom-dropdown-submenu-item:hover {\n  background: #f5f9ff;\n}\n\n.submenu-item-label {\n  font-size: 11px;\n  color: #062229;\n}\n\n.submenu-item-type {\n  font-size: 11.5px;\n  color: #6a8991;\n}\n\n.no-results-message {\n  padding: 12px;\n  text-align: center;\n  color: #6a8991;\n  font-size: 11px;\n  font-style: italic;\n}\n\n// Responsive\n@media (max-width: 768px) {\n  .hubspot-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .hubspot-info-section {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .hubspot-tabs {\n    overflow-x: auto;\n  }\n\n  .mapping-profile-tabs {\n    flex-direction: column;\n    // gap: 12px;\n    align-items: flex-start;\n  }\n\n  .profile-user-list {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .field-name-row {\n    max-width: 100%;\n  }\n\n  .field-row {\n    grid-template-columns: 1fr;\n  }\n\n  .mapping-table-subheader,\n  .mapping-table-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .section-filters {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .automation-indicator-bar {\n    margin-left: 24px;\n  }\n\n  .automation-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 24px;\n  }\n\n  .toggle-switch {\n    width: 100%;\n  }\n\n  .automation-input {\n    width: 100%;\n  }\n\n  .automation-triggers-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .trigger-card {\n    max-width: 100%;\n  }\n\n  .trigger-card-footer {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .trigger-actions {\n    flex-wrap: wrap;\n  }\n}\n\n// Create Trigger Modal\n.create-trigger-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.create-trigger-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0;\n}\n\n.trigger-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.trigger-form-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #142a31;\n}\n\n.trigger-name-input {\n  width: 447px;\n  height: 34px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #365a64;\n  outline: none;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: #365a64;\n  }\n}\n\n.trigger-status-section {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin: 8px 0;\n}\n\n.trigger-checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.trigger-checkbox-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n}\n\n.trigger-rules-container {\n  background: rgba(255, 255, 255, 0);\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 12px;\n  min-height: 95px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.trigger-modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.trigger-modal-cancel {\n  padding: 8px 29px;\n  background: #142b31;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n.trigger-modal-save {\n  padding: 8px 29px;\n  background: #40a0c1;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #3589a8;\n  }\n}\n\n// Connect To Ace Modal\n.connect-to-ace-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.connect-to-ace-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0;\n}\n\n.connect-to-ace-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.connect-to-ace-form-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #142a31;\n}\n\n.connect-to-ace-name-input {\n  width: 447px;\n  height: 34px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #365a64;\n  outline: none;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: #365a64;\n  }\n}\n\n.connect-to-ace-name-select {\n  width: 447px;\n  height: 35px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #365a64;\n  outline: none;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: #365a64;\n  }\n}\n\n.connect-to-ace-modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.connect-to-ace-modal-cancel {\n  padding: 8px 29px;\n  background: #142b31;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n.connect-to-ace-modal-save {\n  padding: 8px 29px;\n  background: #40a0c1;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #3589a8;\n  }\n\n  &:disabled {\n    background: #a0cbd9;\n    cursor: not-allowed;\n  }\n}\n\n.connect-to-ace-form-required {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 1.21;\n  color: #d14343;\n}\n\n// Mapping Tab Wrapper\n.mapping-tab-wrapper {\n  padding: 20px;\n  background: #ffffff;\n}\n\n// Field Dropdown with Submenu\n.field-dropdown-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 32px 6px 10px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #365a64;\n  min-height: 31px;\n  height: 42px;\n  position: relative;\n  box-sizing: border-box;\n\n  &:hover {\n    border-color: #40a0c1;\n  }\n\n  span {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.dropdown-icon-inline {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  min-width: 100%;\n  width: max-content;\n  max-width: 600px;\n}\n\n.custom-dropdown-search {\n  padding: 8px 8px 8px 8px;\n  border-bottom: 1px solid #e0e6eb;\n  flex-shrink: 0;\n  background: #ffffff;\n}\n\n.dropdown-search-input {\n  width: 100%;\n  padding: 6px 10px;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #365a64;\n  outline: none;\n  box-sizing: border-box;\n\n  &:focus {\n    border-color: #40a0c1;\n  }\n\n  &::placeholder {\n    color: #9ba7af;\n  }\n}\n\n.custom-dropdown-options {\n  max-height: 240px;\n  overflow-y: auto;\n  overflow-x: visible;\n  min-width: max-content;\n  width: auto;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d3e1ed;\n    border-radius: 4px;\n\n    &:hover {\n      background: #40a0c1;\n    }\n  }\n}\n\n.custom-dropdown-option {\n  padding: 8px 8px;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #365a64;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  transition: background 0.15s;\n  overflow: visible !important;\n  min-height: 32px;\n  gap: 16px;\n  white-space: nowrap;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n\n  &.has-submenu {\n    padding-right: 32px;\n    overflow: visible !important;\n  }\n\n  > span:first-child {\n    flex: 1;\n    white-space: nowrap;\n  }\n}\n\n.field-type-label {\n  color: #706e6b;\n  font-size: 11px;\n  margin-left: auto;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.submenu-arrow {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.custom-dropdown-submenu {\n  position: fixed;\n  min-width: 280px;\n  max-width: 350px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);\n  z-index: 10000 !important;\n  max-height: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\n.submenu-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  transition: background 0.15s;\n  min-height: auto;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n}\n\n.submenu-option-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n}\n\n.submenu-option-label {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #365a64;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.submenu-option-type {\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  color: #706e6b;\n  line-height: 1.2;\n}\n\n// Ensure parent containers allow overflow\n.mapping-table {\n  overflow: visible !important;\n}\n\n.mapping-table-row td {\n  overflow: visible !important;\n}\n\n.mapping-cell {\n  overflow: visible !important;\n  position: relative;\n}\n\n.opportunity-field-select-container {\n  position: relative;\n  width: 100%;\n}\n\n// Default Value Dropdown styles\n.custom-dropdown {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 32px 6px 10px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #365a64;\n  height: 42px;\n  position: relative;\n  box-sizing: border-box;\n  min-width: 0;\n  width: 100%;\n\n  &:hover {\n    border-color: #40a0c1;\n  }\n}\n\n.dropdown-text {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.dropdown-arrow {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: transform 0.2s;\n\n  &.open {\n    transform: translateY(-50%) rotate(180deg);\n  }\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px rgba(20, 43, 49, 0.15);\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  min-width: max(100%, 215px);\n  width: max-content;\n  max-width: 600px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.dropdown-search {\n  padding: 8px;\n  border-bottom: 1px solid #e0e6eb;\n  flex-shrink: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dropdown-search-input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #365a64;\n  outline: none;\n  box-sizing: border-box;\n\n  &:focus {\n    border-color: #40a0c1;\n  }\n\n  &::placeholder {\n    color: #9ba7af;\n  }\n}\n\n.dropdown-options {\n  max-height: 240px;\n  overflow-y: auto;\n  overflow-x: visible;\n  width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d3e1ed;\n    border-radius: 4px;\n\n    &:hover {\n      background: #40a0c1;\n    }\n  }\n}\n\n.dropdown-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #365a64;\n  display: flex;\n  align-items: center;\n  transition: background 0.15s;\n  white-space: nowrap;\n\n  &:hover {\n    background: #f5f9ff;\n  }\n\n  &.selected {\n    background: #e8f4f8;\n    font-weight: 500;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.option-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// Ensure default-value-cell allows overflow\n.default-value-cell {\n  overflow: visible !important;\n\n  .field-name-input-container {\n    overflow: visible !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
